export const types = {

    GET_STATE_DOCUMENTS_REQUEST: 'GET_STATE_DOCUMENTS_REQUEST',
    GET_STATE_DOCUMENTS_SUCCESS: 'GET_STATE_DOCUMENTS_SUCCESS',
    GET_STATE_DOCUMENTS_FAILURE: 'GET_STATE_DOCUMENTS_FAILURE',

    UPLOAD_DOCUMENTS_REQUEST: 'UPLOAD_DOCUMENTS_REQUEST',
    UPLOAD_DOCUMENTS_SUCCESS: 'UPLOAD_DOCUMENTS_SUCCESS',
    UPLOAD_DOCUMENTS_FAILURE: 'UPLOAD_DOCUMENTS_FAILURE',
}